import RidingResult from './RidingResult'
import Region from './Region'
import MultiSeatResult from './MultiSeatResult'

export default class RegionalResult extends MultiSeatResult {
  protected _region: Region

  protected static filterRidingResults(
    ridingResults: RidingResult[],
    region: Region
  ): RidingResult[] {
    return ridingResults.filter(
      (r: RidingResult): boolean =>
        Region.fromProvince(r.riding.province).key === region.key
    )
  }

  public constructor(ridingResults: RidingResult[], region: Region) {
    super(RegionalResult.filterRidingResults(ridingResults, region))
    this._region = region
  }

  public get region(): Region {
    return this._region
  }
}
